import { render } from "./AutoResizeTextarea.vue?vue&type=template&id=7ac163fe"
import script from "./AutoResizeTextarea.vue?vue&type=script&lang=js"
export * from "./AutoResizeTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__